import { supabase } from '../supabaseClient';

// Client-side helper to call the Netlify function `logEvent`
export async function logEvent({ event_type, target, metadata = {} }) {
  try {
    // Try to enrich with user info if available
    let user_id = null;
    let user_role = 'unknown';
    try {
      const { data } = await supabase.auth.getUser();
      user_id = data?.user?.id ?? null;
      user_role = data?.user?.app_metadata?.role ?? 'unknown';
    } catch (authError) {
      console.warn('Could not fetch user for logging:', authError);
    }

    const response = await fetch('/.netlify/functions/logEvent', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ event_type, target, metadata, user_id, user_role })
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      console.warn('logEvent failed with status', response.status, errorData);
    }
  } catch (e) {
    // Silently ignore logging errors to avoid breaking UI
    console.warn('logEvent network error:', e?.message || e);
  }
}

export default logEvent;

